<template>
  <component :is="to ? RouterLink : 'div'" :to="to" class="stat-group">
    <slot name="label">
      <Text variant="label-small" color="secondary">{{ label }}</Text>
    </slot>
    <slot />
  </component>
</template>

<script setup lang="ts">
import { RouteLocationRaw, RouterLink } from 'vue-router';

import Text from '../text.vue';

/** One figure group inside a `StatsGrid`; `to` makes the whole group a link to where the figures come from */
defineProps<{ label?: string; to?: RouteLocationRaw }>();
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.stat-group {
  --stat-group-divider: 1px solid var(--t-color-neutral-100);

  display: flex;
  flex-direction: column;
  gap: var(--t-spacing-sm);
  min-width: 0;
  color: inherit;
  text-decoration: none;
  padding-left: var(--t-spacing-md);
  border-left: var(--stat-group-divider);

  // The first column sits at the row's left edge, where a leading divider reads as a stray line
  &:first-child {
    padding-left: 0;
    border-left: none;
  }

  // Two by two: only the right column keeps its divider
  @include screen-max-md {
    padding-left: 0;
    border-left: none;

    &:nth-child(even) {
      padding-left: var(--t-spacing-md);
      border-left: var(--stat-group-divider);
    }
  }
}
</style>
